//libs
import { memo, ReactElement } from 'react';

//component
import { frontloadConnect } from 'react-frontload';

import { getPLPData as _getPLPData } from 'shared/store/listingV2/services';
interface APIProps {
  getPLPData: typeof _getPLPData;
  children: ReactElement[];
  isFetching: boolean;
}

const API = ({ children }: APIProps) => {
  return children;
};

//frontload function
const fetch = async ({ getPLPData, isFetching }: APIProps) => {
  //sending isMobile = false as param in getPlpData
  if (isFetching) return getPLPData(false);

  return Promise.resolve(null);
};

export default frontloadConnect(fetch, { onUpdate: true })(memo(API));
